__turbopack_context__.v({
  "bar": "email-updates-bar-module-scss-module__Itn9Sa__bar",
  "expanded": "email-updates-bar-module-scss-module__Itn9Sa__expanded",
  "header": "email-updates-bar-module-scss-module__Itn9Sa__header",
  "subscribe": "email-updates-bar-module-scss-module__Itn9Sa__subscribe",
});
